// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Op-z","slideIn":"Pp-z"};